/**
 * Email Log Service
 * API service for email log operations
 */

import { get, post } from '../../apiClient';
import { API_ENDPOINTS } from '../../config';

const emailLogService = {
  /**
   * Send email to a lead
   * @param {String} leadId - Lead ID
   * @param {Object} emailData - Email data
   * @param {String} emailData.to - Recipient email
   * @param {String} emailData.subject - Email subject
   * @param {String} emailData.bodyHtml - HTML content
   * @param {String} emailData.bodyText - Plain text content
   * @param {Array} emailData.cc - CC recipients (optional)
   * @param {Array} emailData.bcc - BCC recipients (optional)
   * @param {Array} emailData.attachments - Attachments (optional)
   */
  sendEmail: async (leadId, emailData) => {
    try {
      const url = `${API_ENDPOINTS.CRM.LEADS}/${leadId}/emails`;
      const response = await post(url, emailData);

      if (response && (response.responseCode === 200 || response.responseCode === 201)) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to send email'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to send email'
      };
    }
  },

  /**
   * Get email logs for a lead
   * @param {String} leadId - Lead ID
   * @param {Object} options - Query options
   * @param {String} options.type - Filter by type (outgoing/incoming)
   * @param {Number} options.limit - Limit results
   * @param {String} options.sortBy - Sort field
   * @param {String} options.sortOrder - Sort order (asc/desc)
   */
  getEmailLogs: async (leadId, options = {}) => {
    try {
      const params = new URLSearchParams();
      if (options.type) params.append('type', options.type);
      if (options.limit) params.append('limit', options.limit);
      if (options.sortBy) params.append('sortBy', options.sortBy);
      if (options.sortOrder) params.append('sortOrder', options.sortOrder);

      const queryString = params.toString();
      const url = `${API_ENDPOINTS.CRM.LEADS}/${leadId}/emails${queryString ? `?${queryString}` : ''}`;
      
      const response = await get(url);
      
      if (response && (response.responseCode === 200 || response.data)) {
        return {
          success: true,
          emailLogs: response.data?.emailLogs || response.emailLogs || [],
          count: response.data?.count || response.count || 0
        };
      } else {
        return {
          success: false,
          error: response.responseMessage || 'Failed to fetch email logs',
          emailLogs: []
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to fetch email logs',
        emailLogs: []
      };
    }
  }
};

export default emailLogService;

